/* Import polyfills. */
import './functions/polyfills';
import '../../node_modules/objectFitPolyfill/dist/objectFitPolyfill.min.js';

/* :focus-visible polyfill from npm */
import 'focus-visible';

/* Import modules. */
import { Intervaro } from './modules/Intervaro';
import { Modals } from './modules/Modals';
import { Wcag } from './modules/Wcag';
import { Scroll } from './modules/Scroll';
import { Sliders } from './modules/Sliders/';
import { Cookies } from './modules/Cookies';
import { LazyLoad } from './modules/LazyLoad';
import { Accordion } from './modules/Accordion';
import { Scrollbar } from './modules/Scrollbar';
import { Shopify } from './modules/Shopify';
import { Cart } from './modules/Cart';
import { Tabs } from './modules/Tabs';
import { PageTransition } from './modules/PageTransition';
import { Form } from './modules/Form';
import { Product } from './modules/Product';
import { Review } from './modules/Review';
import { CopyPageURL } from './modules/CopyPageURL'

Intervaro.load( () => {
	new Shopify();
	new Cart();
	new Accordion();
	// new Cookies();
	new Product();
	new Modals();
	new Scroll();
	new Scrollbar();
	new Sliders();
	new Tabs();
	new PageTransition();
	new Form();
	new Review();
	new CopyPageURL();
} );

Intervaro.ready( () => {
	new LazyLoad();
	new Wcag();
} );
